export enum Page {
    ROOM,
    PRODUCT,
    SETTING,
    QFP,
}
